import {Requirement, RequirementStatus, RequirementType} from 'lib/entities';

export type DocumentResponse = {
    id: string;
    s3key: string;
    uploadUrl: string;
    name: string;
    insertedAt: string;
    updatedAt: string;
};

/**
 * Common properties used by all components related to requirements
 */
export interface CommonRequirementProps {
    id: string;
    title: string;
    status: string;
}

export const sortRequirements = (requirements: Requirement[]) => {
    return requirements.slice().sort(function (a, b) {
        const aInsertedAt = new Date(a.insertedAt).getTime();
        const aUpdatedAt = new Date(a.updatedAt).getTime();
        const bInsertedAt = new Date(b.insertedAt).getTime();
        const bUpdatedAt = new Date(b.updatedAt).getTime();

        if (a.status === RequirementStatus.OUTSTANDING && b.status === RequirementStatus.OUTSTANDING)
            return aInsertedAt - bInsertedAt;
        if (a.status === RequirementStatus.OUTSTANDING) return -1;
        if (b.status === RequirementStatus.OUTSTANDING) return 1;
        return aUpdatedAt - bUpdatedAt;
    });
};

export const EMPLOYMENT_INFO_TYPE = 'employmentInfo';

/**
 * Utility function to check if banking requirement requirement is submitted
 * @param requirements
 * @return boolean
 */
export const hasPaymentInformationRequirement = (requirements: Requirement[]) => {
    return requirements?.some((r) => r.type === RequirementType.PAYMENT_INFORMATION);
};

/**
 * Utility function to check if authorize payment is enabled
 * @param requirements
 * @return boolean
 */
export const hasAuthorizePaymentRequirement = (requirements: Requirement[]) => {
    return requirements?.some((r) => r.type === RequirementType.PAYMENT_AUTHORIZATION_DOCUSIGN);
};
